module.exports = __webpack_public_path__ + "static/media/P39.5aeee07f.jpg";